import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { IconTextButton } from '@companion-professional/components';
import { PetAndClinicInfo } from '@companion-professional/dctypes';
import { Page } from '../../components/Page';
import { Section } from '../../components/Section';
import { CreateCheckupForPetDialog } from '../../components/CreateCheckupForPetDialog';
import { PetCheckups } from './PetCheckups';
import { PetInfoForm } from './PetInfoForm';

interface PetProps {
  pet: PetAndClinicInfo;
}

// Pet is a page that shows the details of a pet.
// TODO: lots of opportunity for restyling here.  I haven't come up with a good design for displaying data yet, once I
//   do, I'll update this page.
export const Pet: FunctionComponent<PetProps> = ({ pet }) => {
  const navigate = useNavigate();

  return (
    <Page
      title={pet?.name || 'Pet'}
      rightButton={
        <div className="flex flex-row gap-2">
          <CreateCheckupForPetDialog pet={pet} />
        </div>
      }
      wrapWithSection={false}
    >
      <div className="space-y-4">
        <Section>
          <PetInfoForm pet={pet} />
        </Section>

        <Section>
          <PetCheckups pet={pet} />
        </Section>

        <IconTextButton
          size="small"
          variant="secondary"
          onClick={() => {
            navigate('/pets');
          }}
          Icon={ArrowLeft}
        >
          Back To Pets
        </IconTextButton>
      </div>
    </Page>
  );
};
